module.exports = __webpack_public_path__ + "images/9c7a9333aaf33f2e9f78a7f1cb8b58a1.png";